import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";

import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import { LABELS, WARNINGS, TITLES, SUCCESS, ERRORS, SUB_TITLES } from "common/lables";
import { COMMON_JS } from "common/scripts";
import TxtRow from "components/Custom/TxtRow";

import { MASTER_APIs } from "apihandlers/master";

const Expenses = (props: any) => {
  const { setDashMenu } = props;

  const insertAboveRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
        searchQry: "",
        driverCode: false,
      };
      const res: any = await MASTER_APIs.getExpenses(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getCurrencies:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };
  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: "false",
      searchable: "true",
      sortable: "true",
    },
    {
      key: "expenseName",
      name: LABELS.EXPENSE_NAME,
      width: "30%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: "true",
    },
    {
      key: "expenseCode",
      name: LABELS.EXPENSE_CODE,
      width: "15%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: "true",
    },
    {
      key: "expenseDialCode",
      name: LABELS.EXPENSE_DIAL_CODE,
      width: "15%",
      editable: false,
      sortable: true,
      align: "center",
      type: "number",
      searchable: "true",
    },
    {
      key: "modeOfExpense",
      name: LABELS.MODE_OF_EXPENSE,
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      type: "number",
      searchable: "true",
    },
    {
      key: "unitOfMeasurement",
      name: LABELS.UNIT_OF_MEASUREMENT,
      width: "15%",
      editable: false,
      sortable: true,
      align: "center",
      type: "number",
      searchable: "true",
    },
    {
      key: "activeStatusText",
      name: LABELS.ACTIVE,
      width: "5%",
      editable: false,
      sortable: true,
      align: "center",

      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      searchable: "true",
    },

    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageExpenses = () => {
    const expenseName = (
      document.getElementById("expenseName") as HTMLInputElement
    ).value.trim();
    const expenseCode = (
      document.getElementById("expenseCode") as HTMLInputElement
    ).value.trim();
    const expenseDialCode = (
      document.getElementById("expenseDialCode") as HTMLInputElement
    ).value.trim();
    const modeOfExpense = (
      document.getElementById("modeOfExpense") as HTMLInputElement
    ).value.trim();
    const unitOfMeasurement = (
      document.getElementById("unitOfMeasurement") as HTMLInputElement
    ).value.trim();
    let active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = active ? active.value : "";

    // Validations
    let errors = [];
    if (expenseName == "") {
      errors.push({
        id: "mainCategory",
        msg:
          "<span class='bold'>" +
          LABELS.EXPENSE_NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (!active) {
      errors.push({
        id: "activeStatus",
        msg:
          "<span class='bold'>" +
          LABELS.ACTIVE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      expenseName,
      expenseCode: expenseCode.toString(),
      expenseDialCode: Number(expenseDialCode).toString(),
      activeStatus,
      modeOfExpense,
      unitOfMeasurement,
    };
    console.log("args", args);
    setIsSubmit(true);
    MASTER_APIs.manageExpense(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);

        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.EXPENSES}</li>
        </ul>
        <h4>{TITLES.EXPENSES}</h4>
        <p>{SUB_TITLES.EXPENSES}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.EXPENSES}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.EXPENSES + ": " + selectedRow.expenseName
              : "Add New " + LABELS.EXPENSES
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup red">
            <TxtRow
              id={"expenseName"}
              type={"text"}
              label={LABELS.EXPENSE_NAME}
              required={true}
              defaultValue={selectedRow.expenseName}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup">
            <TxtRow
              id={"expenseCode"}
              type={"text"}
              label={LABELS.EXPENSE_CODE}
              required={false}
              defaultValue={selectedRow.expenseCode}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"expenseDialCode"}
              type={"number"}
              label={LABELS.EXPENSE_DIAL_CODE}
              required={false}
              defaultValue={selectedRow.expenseDialCode}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"modeOfExpense"}
              type={"text"}
              label={LABELS.MODE_OF_EXPENSE}
              required={false}
              defaultValue={selectedRow.modeOfExpense}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"unitOfMeasurement"}
              type={"text"}
              label={LABELS.UNIT_OF_MEASUREMENT}
              required={false}
              defaultValue={selectedRow.unitOfMeasurement}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup ">
            <label>
              {LABELS.ACTIVE_STATUS}
              {/* <span>*</span> */}
            </label>
            <RadioBtn
              list={[
                {
                  id: "true",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "false",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div className="formGroup submitBtnWrapper">
            <div className=" flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageExpenses}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Expenses);
